/**
 * package: com.inq.flash.client.data
 * class: ChatRequestMessage
 * @extends com.inq.flash.messagingframework.Message
 * @constructor
 */
com.inq.flash.client.data.ChatRequestMessage = function (chat, isPersistent, agentID, deltaTime, applicationCont, reconnect) {
	com.inq.flash.messagingframework.Message.call(this);
	if (reconnect) {
		this.setMessageType(com.inq.flash.client.data.MessageFields.TYPE_CHAT_REQUEST_RECONNECT);
	} else {
		this.setMessageType(com.inq.flash.client.data.MessageFields.TYPE_CHAT_REQUEST);
	}
	this.addProperty(com.inq.flash.client.data.MessageFields.KEY_CHAT_ID, chat.getChatID());
	this.addPropertyIfNotNull(
		com.inq.flash.client.data.MessageFields.KEY_CONFIG_QUEUE_MESSAGING_SPEC_ID,
		com.inq.flash.client.control.FlashPeer.getQueueMessagingSpecId()
	);
	this.addProperty(com.inq.flash.client.data.MessageFields.KEY_SITE_ID, chat.getSiteID());
	this.addProperty(com.inq.flash.client.data.MessageFields.KEY_LANGUAGE, chat.getLanguage());
	this.addProperty(com.inq.flash.client.data.MessageFields.KEY_SCRIPT_ID, chat.getScriptID());
	this.addProperty(com.inq.flash.client.data.MessageFields.KEY_CONFIG_ENTRY_BUSINESS_UNIT_ID, chat.getBusinessUnitID());
	this.addProperty(com.inq.flash.client.data.MessageFields.KEY_CHAT_TITLE, chat.getChatTitle());
	this.addProperty(com.inq.flash.client.data.MessageFields.KEY_CONFIG_ENTRY_BR_ID, chat.getBrID());
	this.addProperty(com.inq.flash.client.data.MessageFields.KEY_CONFIG_ENTRY_INC_ASSIGNMENT_ID, chat.getIncAssignmentId());
	this.addProperty(com.inq.flash.client.data.MessageFields.KEY_CONFIG_ENTRY_SESSION_ID, chat.getSessionId());
	this.addProperty(com.inq.flash.client.data.MessageFields.KEY_AGENT_ALIAS, chat.getAgentName());
	this.addProperty(com.inq.flash.client.data.MessageFields.KEY_QUEUE_THRESHOLD, chat.getQueueThreshold());
	this.addProperty(com.inq.flash.client.data.MessageFields.KEY_CONFIG_FALLBACK_AGENT_GROUP_ENBLED, chat.fallbackAgentGroupEnabled);

	var automatonSpecData = com.inq.flash.client.control.FlashVars.getAutomatonSpecData();
	var automatonDataMap = automatonSpecData ? automatonSpecData : com.inq.flash.client.control.FlashPeer.getAutomatonDataMap();
	if (automatonDataMap) {
		if (typeof automatonDataMap === "object") {
			automatonDataMap = JSON.stringify(automatonDataMap);
		}
		this.addProperty(com.inq.flash.client.data.MessageFields.KEY_CONFIG_AUTOMATON_DATA_MAP, automatonDataMap);
	}
	var persistentCustomerID = com.inq.flash.client.control.FlashPeer.getPersistentCustomerID();
	if (persistentCustomerID) {
		this.addProperty(com.inq.flash.client.data.MessageFields.KEY_CONFIG_ENTRY_PERSISTENT_CUSTOMER_ID, persistentCustomerID);
	}
	var secureWithCustToken = com.inq.flash.client.control.FlashVars.isSecureWithCustToken();
	if (secureWithCustToken) {
		this.addProperty(com.inq.flash.client.data.MessageFields.KEY_SECURE_CUST_TOKEN, persistentCustomerID || "");
	}

	if (chat.asyncChat) {
		this.addProperty(com.inq.flash.client.data.MessageFields.KEY_CONFIG_IS_ASYNC_ENGAGEMENT, chat.isAsyncChat());
		this.addProperty(com.inq.flash.client.data.MessageFields.KEY_CONFIG_CONVERSATION_CHANNEL, "WEB");
		this.addPropertyIfNotNull(com.inq.flash.client.data.MessageFields.KEY_ASYNC_SURVEY_SPEC_ID, chat.getAsyncSurveySpecID());
		this.addPropertyIfNotNull(com.inq.flash.client.data.MessageFields.KEY_USER_OBJECT, chat.getUserObject());
		this.addPropertyIfNotNull(com.inq.flash.client.data.MessageFields.KEY_CREATE_NEW_CONVERSATION, chat.isCreateNewConversation());
		this.addPropertyIfNotNull(com.inq.flash.client.data.MessageFields.KEY_AUTHENTICATED_USER, com.inq.flash.client.control.FlashPeer.getAuthenticatedUser());
		this.addPropertyIfNotNull(com.inq.flash.client.data.MessageFields.KEY_CONV_TOKEN_ID, com.inq.flash.client.control.FlashPeer.getConversationTokenID());
		this.addPropertyIfNotNull(com.inq.flash.client.data.MessageFields.KEY_CONV_OBJECT_ID, com.inq.flash.client.control.FlashPeer.getConversationObjectID());
	}

	/** @type {boolean} */
	var overrideChatTheme = chat.getOverrideChatTheme();
	/** @type {boolean} */
	var useAgentAliasSpec = chat.getUseAgentAlias();
	/** @type {boolean} */
	var useAgentAliasMxml = com.inq.utils.Util.getConfig("useAgentAlias", false);
	/** @type {boolean} */
	var overrideAgentAlias = com.inq.flash.client.control.FlashVars.getValue("overrideAgentAlias");
	/** @type {boolean} */
	var useAgentAlias = overrideChatTheme == "true" ? useAgentAliasSpec == "true" : useAgentAliasMxml;
	if (overrideAgentAlias === "true") {
		useAgentAlias = false;
	}
	if (useAgentAlias) {
		this.addProperty(com.inq.flash.client.data.MessageFields.KEY_USE_AGENT_ALIAS, com.inq.flash.client.data.MessageFields.DATA_TRUE);
	}
	if (useAgentAlias === true && overrideAgentAlias !== "true") {
		/** @type {string} */
		var defaultAgentAlias = com.inq.flash.client.control.FlashVars.getValue("agentName");
		if (com.inq.utils.Util.isDefaultAgentAlias()) {
			defaultAgentAlias = com.inq.utils.Util.getConfig("defaultAgentAlias", "&nbsp;");
		}
		this.addProperty(com.inq.flash.client.data.MessageFields.KEY_AGENT_ALIAS, defaultAgentAlias);
	}
	if (chat.getLaunchPageMarker() != null && chat.getLaunchPageMarker().length > 0) this.addProperty(com.inq.flash.client.data.MessageFields.KEY_CONFIG_ENTRY_LAUNCH_PAGE, chat.getLaunchPageMarker());
	if (chat.getLaunchType() != null && chat.getLaunchType().length > 0) this.addProperty(com.inq.flash.client.data.MessageFields.KEY_CONFIG_ENTRY_LAUNCH_TYPE, chat.getLaunchType());
	if (chat.getDeviceType() != null && chat.getDeviceType().length > 0) this.addProperty(com.inq.flash.client.data.MessageFields.KEY_CONFIG_ENTRY_DEVICE_TYPE, chat.getDeviceType());
	if (chat.getBrowserType() != null && chat.getBrowserType().length > 0) this.addProperty(com.inq.flash.client.data.MessageFields.KEY_CONFIG_ENTRY_BROWSER_TYPE, chat.getBrowserType());
	if (chat.getBrowserVersion() != null && chat.getBrowserVersion().length > 0) this.addProperty(com.inq.flash.client.data.MessageFields.KEY_CONFIG_ENTRY_BROWSER_VERSION, chat.getBrowserVersion());
	if (chat.getOperatingSystemType() != null && chat.getOperatingSystemType().length > 0) this.addProperty(com.inq.flash.client.data.MessageFields.KEY_CONFIG_ENTRY_OPERATING_SYSTEM_TYPE, chat.getOperatingSystemType());
	if (chat.getExternalCustomerIDs() != null && chat.getExternalCustomerIDs().length > 0) this.addProperty(com.inq.flash.client.data.MessageFields.KEY_EXTERNAL_CUSTOMER_IDS, chat.getExternalCustomerIDs());
	if (chat.getRoutingAllocSpecs() != null) this.addProperty(com.inq.flash.client.data.MessageFields.KEY_ROUTING_ALLOC_SPECS, chat.getRoutingAllocSpecs());
	if (com.inq.flash.client.control.FlashPeer.getCustGeoData()) {
		this.addProperty(com.inq.flash.client.data.MessageFields.KEY_COUNTRY_CODE, com.inq.flash.client.control.FlashPeer.getCustGeoData().country_code);
		this.addProperty(com.inq.flash.client.data.MessageFields.KEY_REGION_CODE, com.inq.flash.client.control.FlashPeer.getCustGeoData().region_code);
	}
	this.addProperty(com.inq.flash.client.data.MessageFields.KEY_CONFIG_AGENT_ATTRIBUTE, chat.getAgentAttributes());
	var /** @type {string} */ agentGroupID = chat.getAgentGroupID();
	if (agentGroupID) {
		this.addProperty(com.inq.flash.client.data.MessageFields.KEY_CONFIG_AGENT_GROUP_ID, agentGroupID);
	}
	/** @type {string} */
	var publicUserId = chat.getPublicUserId();
	if (publicUserId) {
		this.addProperty(com.inq.flash.client.data.MessageFields.KEY_PUBLIC_USER_ID, publicUserId);
	} else {
		/** @type {string} */
		var uniqueAgentName = chat.getUniqueAgentName();
		if (uniqueAgentName) {
			this.addProperty(com.inq.flash.client.data.MessageFields.KEY_AGENT_ID, uniqueAgentName);
		}
	}
	this.addProperty(com.inq.flash.client.data.MessageFields.KEY_CONFIG_VISITOR_ATTRIBUTES, chat.getVisitorAttributes());
	this.addProperty(com.inq.flash.client.data.MessageFields.KEY_CONFIG_RULE_ATTRIBUTES, chat.getRuleAttributes());
	this.addProperty(com.inq.flash.client.data.MessageFields.KEY_CUSTOMER_ID, chat.getCustomerID());
	this.addProperty(com.inq.flash.client.data.MessageFields.KEY_USERNAME, chat.getUsername());
	if (agentID != null && agentID.length > 0) this.addProperty(com.inq.flash.client.data.MessageFields.KEY_AGENT_ID, agentID);
	this.addProperty(com.inq.flash.client.data.MessageFields.KEY_PERSISTENT_FLAG, isPersistent ? "true" : "false");
	if (chat.getAutomatonId() > 0 && !(applicationCont.msgcntAtEntry > 0 && com.inq.flash.client.control.FlashPeer.isPersistentWindow())) {
		this.addProperty(com.inq.flash.client.data.MessageFields.KEY_CHAT_AUTOMATON_ID, chat.getAutomatonId());
		/** @type {object} */
		var automatonFieldsMap = buildAutomatonFieldsMap();
		if (automatonFieldsMap) {
			/** @type {number}*/
			var i = 0;
			for (var key in automatonFieldsMap) {
				this.addProperty(com.inq.flash.client.data.MessageFields.KEY_CHAT_AUTOMATON_FIELD + i + ".name", key);
				this.addProperty(com.inq.flash.client.data.MessageFields.KEY_CHAT_AUTOMATON_FIELD + i++ + ".value", automatonFieldsMap[key]);
			}
		}
		this.addProperty(com.inq.flash.client.data.MessageFields.KEY_CONFIG_ENTRY_LOCATION, JSON.stringify({type: 'chat'}));
		this.addProperty(com.inq.flash.client.data.MessageFields.KEY_CONFIG_ENTRY_INITIATOR, JSON.stringify({
			type: 'br',
			id: chat.brID
		}));
	}
	/* check persistence and msgcntAtEntry >0 then don't assign id */
	this.addProperty(com.inq.flash.client.data.MessageFields.KEY_CONFIG_ENTRY_PAGE_ID, chat.getLaunchPageId());
	this.addProperty(com.inq.flash.client.data.MessageFields.KEY_TIME_DELTA, deltaTime);
	var /** @type {string} */ agentAutoOpenerId = com.inq.flash.client.control.FlashVars.getValue("agentAutoOpenerId");
	if (agentAutoOpenerId != null) this.addProperty(com.inq.flash.client.data.MessageFields.KEY_AGENT_AUTO_OPENER_ID, agentAutoOpenerId);
	var initialConversationCustomerId = com.inq.flash.client.control.PersistenceManager.GetValue(INITIAL_CUSTOMER_ID);
	if (initialConversationCustomerId) {
		this.addProperty(com.inq.flash.client.data.MessageFields.KEY_INITIAL_CLIENT_ID_STRING, initialConversationCustomerId);
	}
	if (chat.pushNotificationDeviceID) {
		this.addProperty(com.inq.flash.client.data.MessageFields.KEY_PUSH_NOTIFICATION_DEVICE_ID, chat.pushNotificationDeviceID);
	}
	if (com.inq.flash.client.chatskins.SkinControl.topicId) {
		this.addProperty(com.inq.flash.client.data.MessageFields.KEY_CONFIG_TOPIC_ID, com.inq.flash.client.chatskins.SkinControl.topicId);
		this.addProperty(com.inq.flash.client.data.MessageFields.KEY_TOPICS_ENABLED, com.inq.flash.client.data.MessageFields.DATA_TRUE);
		if (com.inq.flash.client.chatskins.SkinControl.topicName) {
			this.addProperty(com.inq.flash.client.data.MessageFields.KEY_CONFIG_TOPIC_NAME, com.inq.flash.client.chatskins.SkinControl.topicName);
		}
	}

	/**
	 * Builds a map with parameters for automaton using specified automaton fields
	 *
	 * @return {object}
	 */
	function buildAutomatonFieldsMap() {
		/** @type {object} */
		var automatonFieldsMap;
		/** @type {string} */
		var automatonFields = chat.getAutomatonFields();
		if (automatonFields) {
			try {
				automatonFieldsMap = JSON.parse(automatonFields);
			} catch (e) {
				haxe.Log.trace("Automaton fields parsing to JSON failed: " + Std.string(e));
			}
		}
		/** @type {object} */
		var automatonDatapass = com.inq.flash.client.control.FlashPeer.getAutomatonDatapass();
		if (automatonDatapass) {
			var arr = {};
			for (var ix = 0; ix < automatonDatapass.length; ix++) {
				arr[automatonDatapass[ix].key] = automatonDatapass[ix].value;
			}
			if (!automatonFieldsMap) {
				automatonFieldsMap = {};
			}
			automatonFieldsMap[com.inq.flash.client.data.MessageFields.KEY_DATAPASS] = JSON.stringify(arr);
		}
		return automatonFieldsMap;
	}
};
$hxClasses['com.inq.flash.client.data.ChatRequestMessage'] = com.inq.flash.client.data.ChatRequestMessage;
/** @private @type {Array} */
com.inq.flash.client.data.ChatRequestMessage.__name__ = ["com", "inq", "flash", "client", "data", "ChatRequestMessage"];
/** @private @type {Function} */
com.inq.flash.client.data.ChatRequestMessage.__super__ = com.inq.flash.messagingframework.Message;
for (var k in com.inq.flash.messagingframework.Message.prototype) com.inq.flash.client.data.ChatRequestMessage.prototype[k] = com.inq.flash.messagingframework.Message.prototype[k];
/** @type {com.inq.flash.client.data.ChatRequestMessage} */
com.inq.flash.client.data.ChatRequestMessage.prototype.__class__ = com.inq.flash.client.data.ChatRequestMessage;
